<script setup lang="ts">
import { ChevronsUpDown } from 'lucide-vue-next'

import type { Country } from '@/types/dropdown'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    modelValue: string
    countries: Country[]
    position?: 'top' | 'bottom'
  }>(),
  {
    position: 'bottom'
  }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

const open = ref(false)
const selectedCountry = computed(() => props.countries?.find((c) => c.alpha2Code === props.modelValue))

const selectCountry = (country: Country) => {
  emit('update:modelValue', country.alpha2Code)
  open.value = false
}
</script>

<template>
  <Popover v-model:open="open">
    <PopoverTrigger as-child>
      <Button variant="ghost" class="gap-2 px-2 text-muted-foreground">
        <img v-if="selectedCountry?.flag" :src="selectedCountry.flag" alt="" class="h-4 w-6 shrink-0" />
        <ChevronsUpDown class="h-5 w-5 shrink-0 text-muted-foreground" />
      </Button>
    </PopoverTrigger>
    <PopoverContent class="w-72 p-0" :align="'start'" :side="position === 'top' ? 'top' : 'bottom'">
      <Command>
        <CommandInput :placeholder="t('global.phoneInput.searchPlaceholder')" />
        <CommandList>
          <CommandEmpty>{{ t('global.words.noResult') }}</CommandEmpty>
          <CommandGroup>
            <CommandItem
              v-for="country in countries"
              :key="country.id"
              :value="`${country.name} ${country.alpha2Code} +${country.phonePrefix}`"
              @select="selectCountry(country)"
            >
              <img :src="country.flag" alt="" class="mr-3 h-4 w-6 shrink-0" />
              <span :class="country.alpha2Code === modelValue ? 'font-semibold' : 'font-normal'">
                {{ country.name }} (+{{ country.phonePrefix }})
              </span>
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </Command>
    </PopoverContent>
  </Popover>
</template>
